import React from 'react';
import HeroBanner from '../HeroBanner/HeroBanner';
import './PolicyLayout.css';

const PolicyLayout = ({ title, breadcrumbs, children }) => {
  return (
    <div>
      <HeroBanner title={title} breadcrumbs={breadcrumbs} />
      <section className="policy-section">
        <div className="container">
          {children}
        </div>
      </section>
    </div>
  );
};

export default PolicyLayout;

